import { h, Component } from 'preact';

import { configure } from '../../../../config';

import { Desktop } from './device/desktop.js';
import Home from '../';

import { enablePageRefresh, COMMON_CONFIGS, setTheme } from '../../../../lib/page';
import { isDesktop } from '../../../../lib/device';

import { TrackingProvider, DIMENSION } from '@cube/track';
import { deviceVariance } from '@cube/blocks';


@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.homeYeehaw',
	clientDisplayName: 'clientDisplayName'
})
@deviceVariance()
export default class YeehawHome extends Component {

	componentWillMount() {
		setTheme(this.props.pageConfig);
	}

	componentDidMount() {
		enablePageRefresh(this.props.pageConfig);
	}

	render( props ) {
		if (!isDesktop(props.device)) {
			return (<Home {...props} />);
		}

		return (
			<TrackingProvider {...{ [DIMENSION.componentpath]: 'YeehawHomePage' }}>
				<Desktop {...props} />
			</TrackingProvider>
		);
	}
}
